function alpineModules(Alpine) {
    let alpineStarted = false;

    document.addEventListener('alpine:init', () => {
        document.querySelectorAll('[x-data]:not([x-data*="{"])').forEach(element => {
            if (element.getAttribute('x-data') == '') return;
            element.setAttribute('x-ignore', '');
        });
    });

    Alpine.registerModule = (name) => {
        const element = document.querySelector(`[x-data="${name}"], [x-data^="${name}("]`);

        element.removeAttribute('x-ignore', false);

        if (alpineStarted) {
            Alpine.destroyTree(element);
            Alpine.initTree(element);
        }
    }

    document.addEventListener('alpine:initialized', () => {
        alpineStarted = true;
    });
}

export default alpineModules;